import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CampaignMilestone } from '../../../shared/interfaces';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'mtm-vertical-list-timeline',
  templateUrl: './vertical-list-timeline.component.html',
  styleUrl: './vertical-list-timeline.component.scss',
  standalone: false,
})
export class VerticalListTimelineComponent {
  @Input() timeline: CampaignMilestone[];
  @Input() isHeaderVisible: boolean = false;
  @Input() isDownload: boolean = false;
  @Input() expandable: boolean = true;
  @Input() compact: boolean = false;
  @Input() isCenterAlign: boolean = true;
  @Output() dateClick: EventEmitter<CampaignMilestone> = new EventEmitter<CampaignMilestone>();
  @Input() canEdit: boolean = true;
  @Input() isMilestoneColumnStretch: boolean = true;
  @Input() hasBorder: boolean = false;

  isExpanded: boolean = false;

  gateMilestoneNames: string[] = [
    'GO 360 KICK OFF',
    'GO 360 STRATEGIC NOTE',
    'GO KEY VISUALS',
    'GO PRIORITY PAID MEDIA ASSETS',
    'GO E-RETAIL PDP ASSETS',
    'GO BRIEF MAGELLAN',
    'MARKETING BOOK',
  ];

  public onDateClick(milestone: CampaignMilestone): void {
    this.dateClick.emit(milestone);
  }

  public toggleHeightLimit(): void {
    if (!this.expandable) return;
    this.isExpanded = !this.isExpanded;
  }

  public getFormattedDate(dateString: string): NgbDateStruct {
    const date: Date = new Date(dateString);
    return {
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear(),
    };
  }
}
